export default __webpack_public_path__ + "static/media/horses.af6e74f9.png";